import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, of, Subject } from 'rxjs';
import * as accessControlActions from 'src/app/access-control/store/actions/index';
import * as accessControlSelectors from 'src/app/access-control/store/selectors/access-control-templates.selectors';
import { takeUntil } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedAccessControlService } from 'src/app/shared/components/access-control-information-view-edit/access-control-service.component';

@Component({
    selector: 'nova-shared-text-input-dialog',
    templateUrl: './text-input-dialog.component.html',
    styleUrls: ['./text-input-dialog.component.scss']
})
export class SharedTextInputDialogComponent implements OnDestroy {
    innerClass: string;
    templateNameValidation$: Observable<boolean | null> = of(null);
    private readonly destroy$: Subject<void> = new Subject<void>();
    templateNameForm: FormGroup;
    hasSpaces$: Observable<boolean>;

    constructor(
        public dialogRef: MatDialogRef<SharedTextInputDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly _store: Store,
        private readonly fb: FormBuilder,
        private readonly _sharedAccessControlService: SharedAccessControlService
    ) {
        this.innerClass = data.innerClass;
        this.templateNameForm = this.fb.group({
            templateName: ['', Validators.required]
        });

        this.templateNameValidation$ = this._store.select(
            accessControlSelectors.selectAccessControlTemplateNameValidation
        );

        this.dialogRef
            .beforeClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this._store.dispatch(accessControlActions.resetAccessControlTemplateNameValidation());
            });

        this.hasSpaces$ = this._sharedAccessControlService.handleTemplateNameChanges(
            this.templateNameForm.get('templateName')
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    validateTemplateName(): void {
        if (this.templateNameForm.get('templateName').value) {
            this._store.dispatch(
                accessControlActions.validateAccessControlTemplateName({
                    templateName: this.templateNameForm.get('templateName').value,
                    templateType: this.data.accessControlCompanyTemplateTypeId,
                    resetValidation: false
                })
            );

            this.templateNameValidation$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
                if (res !== null && res === false) {
                    this.saveTemplate();
                }
            });
        }
    }

    saveTemplate(): void {
        this.dialogRef.close({
            templateName: this.templateNameForm.get('templateName').value,
            templateType: this.data.accessControlCompanyTemplateTypeId
        });
    }
}
